import * as moment from 'moment';

/**
 * Utilities for weather and forecast components
 */
export class WeatherUtils {
  /**
   * Get weather icon class given weather conditions
   * Icons: https://erikflowers.github.io/weather-icons/
   * Weather conditions: https://openweathermap.org/weather-conditions
   * @param weather
   * @returns {string}
   */
  public static getIconClass(weather): string {
    switch (weather.weather[0].id) {
      case 200:
        return WeatherUtils.getPrefix(weather) + 'thunderstorm';
      case 201:
        return WeatherUtils.getPrefix(weather) + 'thunderstorm';
      case 202:
        return WeatherUtils.getPrefix(weather) + 'thunderstorm';
      case 210:
        return WeatherUtils.getPrefix(weather) + 'lightning';
      case 211:
        return WeatherUtils.getPrefix(weather) + 'lightning';
      case 212:
        return WeatherUtils.getPrefix(weather) + 'lightning';
      case 221:
        return WeatherUtils.getPrefix(weather) + 'lightning';
      case 230:
        return WeatherUtils.getPrefix(weather) + 'thunderstorm';
      case 231:
        return WeatherUtils.getPrefix(weather) + 'thunderstorm';
      case 232:
        return WeatherUtils.getPrefix(weather) + 'thunderstorm';
      case 300:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 301:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 302:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 310:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 311:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 312:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 313:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 314:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 321:
        return WeatherUtils.getPrefix(weather) + 'sprinkle';
      case 500:
        return WeatherUtils.getPrefix(weather) + 'rain-mix';
      case 501:
        return WeatherUtils.getPrefix(weather) + 'rain-mix';
      case 502:
        return WeatherUtils.getPrefix(weather) + 'rain';
      case 503:
        return WeatherUtils.getPrefix(weather) + 'rain';
      case 504:
        return WeatherUtils.getPrefix(weather) + 'rain';
      case 511:
        return WeatherUtils.getPrefix(weather) + 'sleet';
      case 520:
        return WeatherUtils.getPrefix(weather) + 'showers';
      case 521:
        return WeatherUtils.getPrefix(weather) + 'showers';
      case 522:
        return WeatherUtils.getPrefix(weather) + 'showers';
      case 531:
        return WeatherUtils.getPrefix(weather) + 'showers';
      case 600:
        return WeatherUtils.getPrefix(weather) + 'snow';
      case 601:
        return WeatherUtils.getPrefix(weather) + 'snow';
      case 602:
        return WeatherUtils.getPrefix(weather) + 'snow';
      case 611:
        return WeatherUtils.getPrefix(weather) + 'sleet';
      case 612:
        return WeatherUtils.getPrefix(weather) + 'sleet';
      case 615:
        return WeatherUtils.getPrefix(weather) + 'sleet';
      case 616:
        return WeatherUtils.getPrefix(weather) + 'sleet';
      case 620:
        return WeatherUtils.getPrefix(weather) + 'snow-wind';
      case 621:
        return WeatherUtils.getPrefix(weather) + 'snow-wind';
      case 622:
        return WeatherUtils.getPrefix(weather) + 'snow-wind';
      case 701:
        return WeatherUtils.getPrefix(weather) + 'fog';
      case 711:
        return WeatherUtils.getPrefix(weather) + 'smoke';
      case 721:
        return WeatherUtils.getPrefix(weather) + 'sandstorm';
      case 731:
        return WeatherUtils.getPrefix(weather) + 'dust';
      case 741:
        return WeatherUtils.getPrefix(weather) + 'fog';
      case 751:
        return WeatherUtils.getPrefix(weather) + 'sandstorm';
      case 761:
        return WeatherUtils.getPrefix(weather) + 'dust';
      case 762:
        return WeatherUtils.getPrefix(weather) + 'volcano';
      case 771:
        return WeatherUtils.getPrefix(weather) + 'strong-wind';
      case 781:
        return WeatherUtils.getPrefix(weather) + 'tornado';
      case 800:
        if (moment().isBetween(moment.unix(weather.sys.sunrise), moment.unix(weather.sys.sunset))) {
          return WeatherUtils.getPrefix(weather) + 'sunny'; // Day
        } else {
          return WeatherUtils.getPrefix(weather) + 'clear'; // Night
        }
      case 801:
        return WeatherUtils.getPrefix(weather) + 'cloudy'; // day-cloudy!
      case 802:
        return 'wi-cloudy'; // 'Default' cloudy
      case 803:
        return WeatherUtils.getPrefix(weather) + 'cloudy'; // day-cloudy!
      case 804:
        return WeatherUtils.getPrefix(weather) + 'cloudy-high';
      case 900:
        return WeatherUtils.getPrefix(weather) + 'tornado';
      case 901:
        return WeatherUtils.getPrefix(weather) + 'hurricane';
      case 902:
        return WeatherUtils.getPrefix(weather) + 'hurricane';
      case 903:
        return WeatherUtils.getPrefix(weather) + 'snowflake-cold';
      case 904:
        return WeatherUtils.getPrefix(weather) + 'thermometer';
      case 905:
        return WeatherUtils.getPrefix(weather) + 'strong-wind';
      case 906:
        return WeatherUtils.getPrefix(weather) + 'snow-thunderstorm';
      default:
        return 'wi-na';
    }
  }

  /**
   * Get day and night prefix depending on sunset and sunrise
   * @param weather
   * @returns {string}
   */
  private static getPrefix(weather: any): string {
    return moment().isBetween(moment.unix(weather.sys.sunrise), moment.unix(weather.sys.sunset)) ? 'wi-day-' : 'wi-night-';
  }
}
